import { pocService, pocClient as poc } from "../pocConfig";

/**
 * The resource allows you to download a list of models for which it is possible to create a form for input data.
   The response of this resource is a list of objects consisting of 3 attributes:
   1. module = module/group to which the model belongs, this is only for the purpose of distinguishing models of the 
      same name used differently depending on the business problem
   2. name = model name
   3. primitive = is it a primitive type (String, Long, DateTime) or a complex model, i.e. a business model
 * @returns {*} - Response with list of models
 */
export const getFormModels = async () => {
   return poc.get("/data/meta");
};

export const getModelDetails = (module, model) => {
   return poc.get(`/meta/${module}/${model}`);
};

export const getFormStructure = (formId) => {
   return poc.get(`/queries/${formId}`);
};

export const getForms = () => {
   return poc.get("/queries/forms");
};

export const uploadFieldFile = async (formData, id) => {
   return poc.post(`/commands/${id}/multipart`, formData, {
      headers: { "Content-Type": undefined },
   });
};

/**
 * Add or edit existing record with form data
 * @param {string} formStructureId - Id of form structure (formId)
 * @param {object} data - Object with field id's as keys and their values as values.
   Data object should always contain all fields.
   First key in object is always id field with dataId as value and its required if we want to edit existing record.
   Objects without dataId value will create completely new record with new dataId

   "66057b2b2da90247ae072617": "0db4ddd3-17e3-4802-a47f-381f77539a5b",
   "66057b2b2da90247ae072618": "Punkt44",
   "66057b2b2da90247ae07261b": "24.5615115:34.15651156",
   "66057b2b2da90247ae07261c": true,
   "66057b2b2da90247ae07261e": 133,
   "66057b2b2da90247ae07261f": null,
   ...
 * @returns {*} - 
 */

export const postFormData = (formStructureId, data) => {
   return poc.post(`/commands/${formStructureId}`, data);
};

/**
 * Gets a form with values.
 * @param {string} formId - Id of form structure
 * @param {string} [dataId] - Id of exact data saved in this form structure
 * @returns {*} - Form structure with all fields and their values. Returns only a structure when no dataId is passed.
 */

export const getFormWithData = (formId, dataId) => {
   if (dataId && !dataId.includes("-")) return;
   const url = dataId ? `/queries/${formId}/${dataId}` : `/queries/${formId}`;
   return poc.get(url);
};

export const getDataQueries = () => {
   return poc.post("/data/queries/paginated", {
      type: "agile.Task",
      properties: { name: "Backend", type: "Backend" },
   });
};

export const getQuestionnaire = (formId) => {
   return poc.post(`/commands/questionnaires/${formId}`);
};

export const saveFormStructure = (data) => {
   return poc.post("/commands/builder", data);
};

export const editFormStructure = (data, dataId) => {
   return poc.put(`/commands/builder/${dataId}`, data);
};

export const deleteFormStructure = (dataId) => {
   return poc.delete(`/commands/builder/${dataId}`);
};

export const copyFormStructure = (dataId) => {
   return poc.post(`/commands/builder/${dataId}/copy`);
};

export const getFormsList = async () => {
   let requestUrl = `${pocService}/queries/forms`;
   return poc.get(requestUrl);
};

export const getV3DataUrl = (dataUrl) => {
   return poc.get(dataUrl);
};

export const getUpdatedData = (urlId, fieldId, data) => {
   let requestUrl = `${pocService}/field/data/u/${urlId}?c=${fieldId}`;
   return poc.patch(requestUrl, data);
};

export const patchFormMethods = (id, methods) => {
   return poc.patch(`/commands/builder/${id}/methods`, methods);
};

export const getFormActions = (module, model) => {
   return poc.get(`/meta/actions/${module}/${model}`);
};
